import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AdminNavbar from "../../../components/admin_navbar";
import AdminSideMenu from "../../../components/admin_side_menu";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

const Store = () => {
  let { id } = useParams();

  const navigate = useNavigate();

  const [store, setStore] = useState({});

  var apiBaseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    let accessToken = localStorage.getItem("strutspos_access_token");
    if (!accessToken) {
      navigate("/");
    }

    window.scrollTo(0, 0);

    var url = apiBaseURL + "/stores/" + id;

    const config = {
      headers: {
        "x-strutspos-token": accessToken,
        "x-strutspos-application": "user",
      },
    };

    axios
      .get(url, config)
      .then((response) => {
        let storeData = JSON.parse(JSON.stringify(response.data));
        setStore(storeData);
      })
      .catch((err) => console.error("fetchStores err = " + err.message));
  }, [apiBaseURL, id, navigate]);

  return (
    <div className="modern-admin-layout">
      <AdminNavbar />

      <div className="admin-container">
        <div className="admin-sidebar">
          <AdminSideMenu />
        </div>

        <main className="admin-main-content">
          {/* Modern Store Header */}
          <div className="dashboard-header-modern">
            <div className="dashboard-header-content">
              <h1 className="dashboard-title">Store Details</h1>
              <p className="dashboard-subtitle">
                View and manage store information
              </p>
            </div>
            <div className="dashboard-actions">
              <Link to="/stores" className="modern-button outline">
                ← Back to Stores
              </Link>
            </div>
          </div>

          {/* Store Profile Card */}
          <div className="profile-card-modern">
            <div className="profile-header">
              <div className="profile-avatar">
                <span>🏪</span>
              </div>
              <div className="profile-info">
                <h2 className="profile-name">{store.name}</h2>
                <p className="profile-subtitle">Store #{store.id}</p>
                <div className="profile-status">
                  <span className="status-badge active">Active</span>
                </div>
              </div>
            </div>
          </div>

          {/* Store Details Grid */}
          <div className="details-grid">
            <div className="detail-card-modern">
              <div className="detail-card-header">
                <h3>Contact Information</h3>
                <span className="detail-icon">📞</span>
              </div>
              <div className="detail-content">
                <div className="detail-row">
                  <span className="detail-label">Phone Number:</span>
                  <span className="detail-value">
                    {store.phone_number || "Not provided"}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Email:</span>
                  <span className="detail-value">
                    {store.email || "Not provided"}
                  </span>
                </div>
              </div>
            </div>

            <div className="detail-card-modern">
              <div className="detail-card-header">
                <h3>Location Details</h3>
                <span className="detail-icon">📍</span>
              </div>
              <div className="detail-content">
                <div className="detail-row">
                  <span className="detail-label">Location:</span>
                  <span className="detail-value">
                    {store.location || "Not specified"}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Address:</span>
                  <span className="detail-value">
                    {store.address || "Not provided"}
                  </span>
                </div>
              </div>
            </div>

            <div className="detail-card-modern">
              <div className="detail-card-header">
                <h3>Store Information</h3>
                <span className="detail-icon">ℹ️</span>
              </div>
              <div className="detail-content">
                <div className="detail-row">
                  <span className="detail-label">Store Name:</span>
                  <span className="detail-value">{store.name}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Created Date:</span>
                  <span className="detail-value">
                    {store.created_at
                      ? new Date(store.created_at).toLocaleDateString()
                      : "Unknown"}
                  </span>
                </div>
              </div>
            </div>

            <div className="detail-card-modern">
              <div className="detail-card-header">
                <h3>Quick Actions</h3>
                <span className="detail-icon">⚡</span>
              </div>
              <div className="detail-content">
                <div className="action-buttons">
                  <button className="modern-button primary small">
                    Edit Store
                  </button>
                  <button className="modern-button outline small">
                    View Reports
                  </button>
                  <button className="modern-button outline small">
                    Store Settings
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Information Card */}
          <div className="info-card-modern">
            <div className="info-header">
              <h3>Store Overview</h3>
              <p>Complete store information and status</p>
            </div>
            <div className="info-content">
              <div className="info-grid">
                <div className="info-item">
                  <span className="info-label">Store ID</span>
                  <span className="info-value">#{store.id}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Status</span>
                  <span className="info-value">
                    <span className="status-badge active">Active</span>
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">Last Updated</span>
                  <span className="info-value">
                    {store.updated_at
                      ? new Date(store.updated_at).toLocaleDateString()
                      : "Unknown"}
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">Total Records</span>
                  <span className="info-value">1 Store</span>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Store;
